import { useState, type FormEvent } from "react";
import { Bouton } from "@/composants/ui/bouton";
import { Champ } from "@/composants/ui/champ";
import { Erreur } from "@/composants/ui/etats";
import { ErreurApi } from "@/client/api";
import { useSessionClient } from "@/client/session";

/**
 * L'accueil du client.
 *
 * Le ton n'est pas celui de l'outil interne : on s'adresse ici à un particulier
 * qui suit ses travaux, pas à un collaborateur qui gère des dossiers. Le fond
 * clair plutôt que l'anthracite marque cette différence dès la première seconde.
 */
export function PageConnexionClient() {
  const { connexion } = useSessionClient();
  const [email, setEmail] = useState("");
  const [motDePasse, setMotDePasse] = useState("");
  const [erreur, setErreur] = useState<string | null>(null);
  const [enCours, setEnCours] = useState(false);

  async function soumettre(evenement: FormEvent) {
    evenement.preventDefault();
    setErreur(null);
    setEnCours(true);
    try {
      await connexion(email, motDePasse);
    } catch (cause) {
      setErreur(cause instanceof ErreurApi ? cause.message : "Une erreur est survenue.");
    } finally {
      setEnCours(false);
    }
  }

  return (
    <main className="flex min-h-full items-center justify-center px-4 py-10">
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          <p className="text-2xl font-semibold tracking-[0.2em] text-anthracite">LABGEST</p>
          <p className="mt-1 text-sm text-encre-douce">Les Ateliers Bordelais · Natural Design</p>
          <p className="mt-6 text-lg font-medium text-encre">Votre espace</p>
          <p className="mt-1 text-sm text-encre-douce">
            Suivez l'avancement de vos travaux et retrouvez vos documents.
          </p>
        </div>

        <form
          onSubmit={soumettre}
          noValidate
          className="flex flex-col gap-4 rounded-[6px] border border-filet bg-white p-6"
        >
          {erreur ? <Erreur message={erreur} /> : null}

          <Champ
            libelle="Adresse électronique"
            type="email"
            name="email"
            autoComplete="username"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Champ
            libelle="Mot de passe"
            type="password"
            name="mot_de_passe"
            autoComplete="current-password"
            required
            value={motDePasse}
            onChange={(e) => setMotDePasse(e.target.value)}
          />

          <Bouton type="submit" variante="principal" disabled={enCours}>
            {enCours ? "Connexion…" : "Accéder à mon espace"}
          </Bouton>

          <p className="text-xs text-encre-douce">
            Vos identifiants vous ont été communiqués par votre interlocuteur chez
            Les Ateliers Bordelais.
          </p>
        </form>

        <p className="mt-6 text-center text-xs text-encre-douce">
          <a href="/" className="underline underline-offset-4 hover:text-encre">
            Vous êtes collaborateur ? Accéder à l'application
          </a>
        </p>
      </div>
    </main>
  );
}
